import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../../../pipes/pipes.module";
import { MaterialModule } from "../../../components/material/material.module";
import { CaracteristicaComponent } from "./caracteristica/caracteristica.component";
import { CaracteristicaService } from "../../../providers/caracteristica.service";
import { CrearCaracteristicaComponent } from "./crear-caracteristica/crear-caracteristica.component";
import { CrearCaracteristicaDialog } from "./crear-caracteristica/crear-caracteristica-dialog/crear-caracteristica-dialog.component";
import { EditarCaracteristicaDialog } from "./editar-caracteristica/editar-caracteristica-dialog/editar-caracteristica-dialog.component";
import { EliminarCaracteristicaComponent } from "./eliminar-caracteristica/eliminar-caracteristica.component";
import { EliminarCaracteristicaDialog } from "./eliminar-caracteristica/eliminar-caracteristica-dialog/eliminar-caracteristica-dialog.component";
import { EditarCaracteristicaComponent } from "./editar-caracteristica/editar-caracteristica.component";
import { IrCaracteristicaComponent } from "./ir-caracteristica/ir-caracteristica.component";
import { ListarCaracteristicasComponent } from "./listar-caracteristicas/listar-caracteristicas.component";
import { OrdenCaracteristicaComponent } from "./orden-caracteristica/orden-caracteristica.component";
import { VerCaracteristicasComponent } from "./ver-caracteristicas/ver-caracteristicas.component";
import { ValorCaracteristicaModule } from "./valores-caracteristica/valor-caracteristica.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        RouterModule,
        MaterialModule,
        ValorCaracteristicaModule,
    ],
    declarations: [
        CaracteristicaComponent,
        CrearCaracteristicaComponent,
        CrearCaracteristicaDialog,
        EditarCaracteristicaComponent,
        EditarCaracteristicaDialog,
        EliminarCaracteristicaComponent,
        EliminarCaracteristicaDialog,
        IrCaracteristicaComponent,
        ListarCaracteristicasComponent,
        OrdenCaracteristicaComponent,
        VerCaracteristicasComponent
    ],
    providers: [
        CaracteristicaService
    ],
    entryComponents: [
        CrearCaracteristicaDialog,
        EditarCaracteristicaDialog,
        EliminarCaracteristicaDialog,
    ],
    exports: [
        CaracteristicaComponent,
        CrearCaracteristicaComponent,
        EditarCaracteristicaComponent,
        EliminarCaracteristicaComponent,
        IrCaracteristicaComponent,
        ListarCaracteristicasComponent,
        OrdenCaracteristicaComponent,
        VerCaracteristicasComponent
    ]
})
export class CaracteristicaModule { }